"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReconnectingWebSocketProvider = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _providers = require("@ethersproject/providers");
var _util = require("@blockwell/util");
var _RpcProvider = require("./RpcProvider");
const WEBSOCKET_PING_INTERVAL = 120000;
const WEBSOCKET_PONG_TIMEOUT = 10000;
const WEBSOCKET_RECONNECT_DELAY = 100;

/**
 * The relevant bits from the DOM WebSocket interface.
 */

const WebSocketProviderClass = () => class {};
class ReconnectingWebSocketProvider extends WebSocketProviderClass() {
  constructor(_url, _chain, _pingInterval = WEBSOCKET_PING_INTERVAL) {
    super();
    (0, _defineProperty2.default)(this, "provider", void 0);
    (0, _defineProperty2.default)(this, "events", []);
    (0, _defineProperty2.default)(this, "requests", {});
    (0, _defineProperty2.default)(this, "multiSubs", []);
    (0, _defineProperty2.default)(this, "multiSubFuncs", {});
    (0, _defineProperty2.default)(this, "handler", {
      get(target, prop, receiver) {
        if (prop === "multiLogs" || prop === "stopMultiLogs" || prop === "estimateGas") {
          return target[prop].bind(target);
        }
        const value = target.provider && Reflect.get(target.provider, prop, receiver);
        return value instanceof Function ? value.bind(target.provider) : value;
      }
    });
    this._url = _url;
    this._chain = _chain;
    this._pingInterval = _pingInterval;
    this.create();
    return new Proxy(this, this.handler);
  }
  async estimateGas(transaction) {
    return _RpcProvider.RpcProvider.estimateGas(this.provider, await this.provider.estimateGas(transaction), transaction);
  }
  async multiLogs(address, topics, listener) {
    let hasTopics = (topics === null || topics === void 0 ? void 0 : topics.length) > 0;
    let params = {
      address
    };
    if (hasTopics) {
      params.topics = topics;
    }
    let sub = {
      tag: "multi:" + address.join(",") + (hasTopics ? ":" + topics.join(",") : ""),
      address,
      topics: hasTopics ? topics : undefined,
      listener,
      params
    };
    this.multiSubs.push(sub);
    let func = this.multiSubFuncs[sub.tag];
    if (!func) {
      func = {
        tag: sub.tag,
        params: sub.params,
        listener: (...data) => {
          for (let it of this.multiSubs) {
            if (it.tag === func.tag) {
              it.listener(...data);
            }
          }
        }
      };
      this.multiSubFuncs[sub.tag] = func;
      await this.provider._subscribe(func.tag, ["logs", func.params], func.listener);
    }
  }
  stopMultiLogs(listener) {
    let index = this.multiSubs.findIndex(it => it.listener === listener);
    if (index > -1) {
      let sub = this.multiSubs[index];
      this.multiSubs.splice(index, 1);
      if (!this.multiSubs.find(it => it.tag === sub.tag)) {
        let func = this.multiSubFuncs[sub.tag];
        delete this.multiSubFuncs[sub.tag];
        const subId = this.provider._subIds[sub.tag];
        if (subId) {
          delete this.provider._subIds[sub.tag];
          return subId.then(subId => {
            if (!this.provider._subs[subId]) {
              return;
            }
            delete this.provider._subs[subId];
            return this.provider.send("eth_unsubscribe", [subId]);
          });
        }
      }
    }
  }
  create() {
    if (this.provider) {
      this.events = [...this.events, ...this.provider._events];
      this.requests = {
        ...this.requests,
        ...this.provider._requests
      };
    }
    let provider = new _providers.WebSocketProvider(this._url, this._chain);
    let pingInterval;
    let pongTimeout;
    let ws = provider._websocket;
    const openListener = () => {
      pingInterval = setInterval(() => {
        Promise.race([provider.getBlockNumber(), (0, _util.delay)(WEBSOCKET_PONG_TIMEOUT).then(() => false)]).then(it => {
          if (it === false) {
            ws.close();
          } else {
            provider.emit("debug", {
              action: "keepalive",
              provider
            });
          }
        });
      }, this._pingInterval);
      let event;
      while (event = this.events.pop()) {
        provider._events.push(event);
        provider._startEvent(event);
      }
      for (const key in this.requests) {
        provider._requests[key] = this.requests[key];
        ws.send(this.requests[key].payload);
        delete this.requests[key];
      }
      for (let sub of Object.values(this.multiSubFuncs)) {
        provider._subscribe(sub.tag, ["logs", sub.params], sub.listener);
      }
      provider.emit("debug", {
        action: "open",
        provider
      });
    };
    if ("on" in ws) {
      ws.addEventListener("open", openListener);
      ws.on("close", code => {
        provider._wsReady = false;
        if (pingInterval) clearInterval(pingInterval);
        if (pongTimeout) clearTimeout(pongTimeout);
        if (code !== 1000) {
          setTimeout(() => this.create(), WEBSOCKET_RECONNECT_DELAY);
          provider.emit("debug", {
            action: "reconnect",
            provider,
            code
          });
        } else {
          provider.emit("debug", {
            action: "close",
            provider,
            code
          });
        }
      });
      ws.on("error", err => {
        provider.emit("debug", {
          action: "error",
          error: err
        });
        setTimeout(() => this.create(), WEBSOCKET_RECONNECT_DELAY);
      });
    } else {
      ws.addEventListener("open", openListener);
      ws.addEventListener("close", event => {
        provider._wsReady = false;
        if (pingInterval) clearInterval(pingInterval);
        if (pongTimeout) clearTimeout(pongTimeout);
        if (event.code !== 1000) {
          setTimeout(() => this.create(), WEBSOCKET_RECONNECT_DELAY);
          provider.emit("debug", {
            action: "reconnect",
            provider,
            code: event.code
          });
        } else {
          provider.emit("debug", {
            action: "close",
            provider,
            code: event.code
          });
        }
      });
    }
    this.provider = provider;
  }
}
exports.ReconnectingWebSocketProvider = ReconnectingWebSocketProvider;
//# sourceMappingURL=websocket.js.map